import { VariantProps, cva } from 'class-variance-authority';

import React from 'react';

const spacerVariants = cva('h-0', {
  variants: {
    size: {
      96: 'h-96',
      80: 'h-80',
      72: 'h-72',
      64: 'h-64',
      60: 'h-60',
      56: 'h-56',
      52: 'h-52',
      48: 'h-48',
      44: 'h-44',
      40: 'h-40',
      36: 'h-36',
      32: 'h-32',
      28: 'h-28',
      24: 'h-24',
      20: 'h-20',
      16: 'h-16',
      14: 'h-14',
      12: 'h-12',
      11: 'h-11',
      10: 'h-10',
      9: 'h-9',
      8: 'h-8',
      7: 'h-7',
      6: 'h-6',
      5: 'h-5',
      4: 'h-4',
      3.5: 'h-3.5',
      3: 'h-3',
      2.5: 'h-2.5',
      2: 'h-2',
      1.5: 'h-1.5',
      1: 'h-1',
      0.5: 'h-0.5',
      0.25: 'h-0.25',
      0: 'h-0',
      default: 'h-0',
    },
    lg: {
      96: 'lg:h-96',
      80: 'lg:h-80',
      72: 'lg:h-72',
      64: 'lg:h-64',
      60: 'lg:h-60',
      56: 'lg:h-56',
      52: 'lg:h-52',
      48: 'lg:h-48',
      44: 'lg:h-44',
      40: 'lg:h-40',
      36: 'lg:h-36',
      32: 'lg:h-32',
      28: 'lg:h-28',
      24: 'lg:h-24',
      20: 'lg:h-20',
      16: 'lg:h-16',
      14: 'lg:h-14',
      12: 'lg:h-12',
      11: 'lg:h-11',
      10: 'lg:h-10',
      9: 'lg:h-9',
      8: 'lg:h-8',
      7: 'lg:h-7',
      6: 'lg:h-6',
      5: 'lg:h-5',
      4: 'lg:h-4',
      3.5: 'lg:h-3.5',
      3: 'lg:h-3',
      2.5: 'lg:h-2.5',
      2: 'lg:h-2',
      1.5: 'lg:h-1.5',
      1: 'lg:h-1',
      0.5: 'lg:h-0.5',
      0.25: 'lg:h-0.25',
      0: 'lg:h-0',
    },
    sm: {
      96: 'sm:h-96',
      80: 'sm:h-80',
      72: 'sm:h-72',
      64: 'sm:h-64',
      60: 'sm:h-60',
      56: 'sm:h-56',
      52: 'sm:h-52',
      48: 'sm:h-48',
      44: 'sm:h-44',
      40: 'sm:h-40',
      36: 'sm:h-36',
      32: 'sm:h-32',
      28: 'sm:h-28',
      24: 'sm:h-24',
      20: 'sm:h-20',
      16: 'sm:h-16',
      14: 'sm:h-14',
      12: 'sm:h-12',
      11: 'sm:h-11',
      10: 'sm:h-10',
      9: 'sm:h-9',
      8: 'sm:h-8',
      7: 'sm:h-7',
      6: 'sm:h-6',
      5: 'sm:h-5',
      4: 'sm:h-4',
      3.5: 'sm:h-3.5',
      3: 'sm:h-3',
      2.5: 'sm:h-2.5',
      2: 'sm:h-2',
      1.5: 'sm:h-1.5',
      1: 'sm:h-1',
      0.5: 'sm:h-0.5',
      0.25: 'sm:h-0.25',
      0: 'sm:h-0',
    },
    md: {
      96: 'md:h-96',
      80: 'md:h-80',
      72: 'md:h-72',
      64: 'md:h-64',
      60: 'md:h-60',
      56: 'md:h-56',
      52: 'md:h-52',
      48: 'md:h-48',
      44: 'md:h-44',
      40: 'md:h-40',
      36: 'md:h-36',
      32: 'md:h-32',
      28: 'md:h-28',
      24: 'md:h-24',
      20: 'md:h-20',
      16: 'md:h-16',
      14: 'md:h-14',
      12: 'md:h-12',
      11: 'md:h-11',
      10: 'md:h-10',
      9: 'md:h-9',
      8: 'md:h-8',
      7: 'md:h-7',
      6: 'md:h-6',
      5: 'md:h-5',
      4: 'md:h-4',
      3.5: 'md:h-3.5',
      3: 'md:h-3',
      2.5: 'md:h-2.5',
      2: 'md:h-2',
      1.5: 'md:h-1.5',
      1: 'md:h-1',
      0.5: 'md:h-0.5',
      0.25: 'md:h-0.25',
      0: 'md:h-0',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

type SpacerProps = {
  lg?: VariantProps<typeof spacerVariants>['lg'];
  sm?: VariantProps<typeof spacerVariants>['sm'];
  md?: VariantProps<typeof spacerVariants>['md'];
  size?: VariantProps<typeof spacerVariants>['size'];
};

/**
 * Spacer Component
 *
 * @param lg - used for breakpoint desktop
 * @param md - used for breakpoint tablet
 * @param sm - used for breakpoint mobile
 * @param size - used for custom size on all breakpoints, works only when lg, md, sm props are not provided
 *
 **/

export function Spacer({ lg, sm, md, size }: SpacerProps) {
  return <div className={spacerVariants({ lg, sm, md, size })}></div>;
}
